import { Box, Image, HStack, IconButton, Spinner } from '@chakra-ui/react';

import { MessageAttachment } from '@/features/messages/messages.types';
import { FiMaximize2, FiDownload } from 'react-icons/fi';

export const MessageAttachmentImage = ({
  isUser,
  isAIAgent,
  handleImageClick,
  handleDownloadImage,
  attachment,
  messageStatus,
}: {
  isUser: boolean;
  isAIAgent: boolean;
  messageStatus: string;
  attachment: MessageAttachment;
  handleImageClick: (imageUrl: string) => void;
  handleDownloadImage: (imageUrl: string, imageName?: string) => void;
}) => {
  if (!attachment) {
    return null;
  }

  return (
    <Box
      position="relative"
      opacity={
        messageStatus === 'pending' || messageStatus === 'sending' ? 0.8 : 1
      }
    >
      {/* Add loading indicator for pending and sending states */}
      {(messageStatus === 'pending' || messageStatus === 'sending') && (
        <Spinner
          size="sm"
          position="absolute"
          top="3px"
          right="3px"
          color="white"
        />
      )}
      <Box position="relative" overflow="hidden" borderRadius="md">
        <Image
          src={attachment.file_url}
          alt={attachment.file_name || 'Attachment'}
          borderRadius="md"
          maxHeight="200px"
          width="auto"
          objectFit="cover"
          cursor="pointer"
          onClick={() => handleImageClick(attachment.file_url)}
          transition="transform 0.2s"
          _hover={{ transform: 'scale(1.02)' }}
        />
        <HStack
          position="absolute"
          top="2"
          right="2"
          gap={1}
          opacity="0"
          transition="opacity 0.2s"
          _groupHover={{ opacity: 1 }}
          as="div"
          role="group"
        >
          <IconButton
            aria-label="View full image"
            size="xs"
            colorPalette={isUser ? 'gray' : isAIAgent ? 'green' : 'blue'}
            variant="solid"
            onClick={(e) => {
              e.stopPropagation();
              handleImageClick(attachment.file_url);
            }}
            borderRadius="full"
          >
            <FiMaximize2 />
          </IconButton>
          <IconButton
            aria-label="Download image"
            size="xs"
            colorPalette={isUser ? 'gray' : isAIAgent ? 'green' : 'blue'}
            variant="solid"
            onClick={(e) => {
              e.stopPropagation();
              handleDownloadImage(attachment.file_url, attachment.file_name);
            }}
            borderRadius="full"
          >
            <FiDownload />
          </IconButton>
        </HStack>
      </Box>
    </Box>
  );
};
